<template>
    <div class="row py-2">
        <div class="col-3 pt-2 ps-0">
            <ul class="list-unstyled settings-nav">
                <li class="mt-2" @click="onTabClick(0)"
                    :class="{
                        'active': selectedTabIndex == 0,
                        'settings-link': selectedTabIndex != 0
                    }">
                    Account info
                </li>
            </ul>
        </div>
        <div class="col-9">
            <account-info v-show="selectedTabIndex == 0" />
        </div>
    </div>
    <div class="row">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-4 pt-3 border-top">
            <button type="button"
                    class="btn btn-link text-dark text-decoration-none"
                    aria-label="Close"
                    @click="onCloseClicked">
                Exit
            </button>
        </div>
    </div>

</template>

<script setup lang="ts">
    import { ref } from "vue";
    import AccountInfo from "@/guiide/components/userSettings/AccountInfo.vue";

    const emit = defineEmits(['exit']);
    const selectedTabIndex = ref(0);

    function onCloseClicked() {
        emit('exit');
    }

    function onTabClick(index: number) {
        selectedTabIndex.value = index;
    }
</script>

<style scoped>
    .settings-nav > li {
        margin: 18px 0;
        cursor: pointer;
    }

        .settings-nav > li:hover {
            font-weight: bold;
        }

        .settings-nav > li > a {
            color: #000;
            text-decoration: none;
        }

            .settings-nav > li > a:hover {
                font-weight: bold;
            }

    .settings-nav .active {
        font-weight: bold;
        border-left: 3px solid #2d70f4;
        padding-left: 10px;
    }

    .settings-link {
        font-weight: normal;
    }
</style>
